// athkar-almasaa.js
import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Dzikir Petang - Benteng Muslim - Dzikir Pagi dan Petang";
const DESCRIPTION = "Dzikir petang dari Benteng Muslim. Tekan lingkaran untuk mencatat setiap bacaan dzikir dengan penghitung otomatis yang menghitung target dan sisa untuk setiap dzikir petang.";
const KEYWORDS = "dzikir petang, benteng muslim, dzikir pagi dan petang, dzikir islami, tasbih petang";
const OG_URL = "https://do-calculate.com/calculator/id/athkar-almasaa/";

const athkarList = [
  {
    key: "ayat_kursi",
    title: "Ayat Kursi",
    text: "Aku berlindung kepada Allah dari setan yang terkutuk\nAllah, tidak ada Tuhan selain Dia, Yang Maha Hidup, Yang Maha Mandiri. Tidak mengantuk dan tidak tidur. Milik-Nya apa yang ada di langit dan apa yang ada di bumi. Siapakah yang dapat memberi syafaat di sisi-Nya tanpa izin-Nya? Dia mengetahui apa yang di hadapan mereka dan apa yang di belakang mereka, dan mereka tidak mengetahui sesuatu apa pun tentang ilmu-Nya kecuali apa yang Dia kehendaki. Kursi-Nya meliputi langit dan bumi. Dan Dia tidak merasa berat memelihara keduanya, dan Dia Maha Tinggi, Maha Besar.",
    fadl: "Barangsiapa membacanya ketika petang, ia akan dilindungi dari jin hingga pagi",
    count: 1,
  },
  {
    key: "baqara_285",
    title: "Penutup Surat Al-Baqarah",
    text: "Aku berlindung kepada Allah dari setan yang terkutuk\nRasul telah beriman kepada apa yang diturunkan kepadanya dari Tuhannya, demikian pula orang-orang yang beriman. Semuanya beriman kepada Allah, malaikat-malaikat-Nya, kitab-kitab-Nya, dan rasul-rasul-Nya. (Mereka berkata), 'Kami tidak membeda-bedakan seorang pun dari rasul-rasul-Nya.' Dan mereka berkata, 'Kami dengar dan kami taat. Ampunilah kami, ya Tuhan kami, dan kepada-Mu tempat kembali.' Allah tidak membebani seseorang melainkan sesuai dengan kesanggupannya. Ia mendapat pahala (dari kebajikan) yang diusahakannya dan ia mendapat siksa (dari kejahatan) yang dikerjakannya. (Mereka berdoa), 'Ya Tuhan kami, janganlah Engkau hukum kami jika kami lupa atau kami bersalah. Ya Tuhan kami, janganlah Engkau bebankan kepada kami beban yang berat sebagaimana Engkau bebankan kepada orang-orang sebelum kami. Ya Tuhan kami, janganlah Engkau pikulkan kepada kami apa yang tidak sanggup kami memikulnya. Maafkanlah kami, ampunilah kami, dan rahmatilah kami. Engkaulah pelindung kami, maka tolonglah kami menghadapi orang-orang kafir.'",
    fadl: "Barangsiapa membaca dua ayat terakhir dari Surat Al-Baqarah pada suatu malam, maka itu sudah cukup baginya",
    count: 1,
  },
  {
    key: "ikhlas",
    title: "Surat Al-Ikhlas",
    text: "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang\nKatakanlah: Dialah Allah, Yang Maha Esa. Allah adalah Tuhan yang bergantung kepada-Nya segala sesuatu. Dia tidak beranak dan tidak diperanakkan. Dan tidak ada seorang pun yang setara dengan Dia.",
    fadl: "Barangsiapa membacanya ketika pagi dan petang, maka itu akan mencukupinya dari segala sesuatu",
    count: 3,
  },
  {
    key: "falaq",
    title: "Surat Al-Falaq",
    text: "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang\nKatakanlah: Aku berlindung kepada Tuhan yang menguasai subuh, dari kejahatan makhluk-Nya, dari kejahatan malam apabila telah gelap gulita, dari kejahatan perempuan-perempuan penyihir yang meniup pada buhul-buhul (talinya), dan dari kejahatan orang yang dengki apabila ia dengki.",
    fadl: "",
    count: 3,
  },
  {
    key: "nas",
    title: "Surat An-Nas",
    text: "Dengan nama Allah Yang Maha Pengasih, Maha Penyayang\nKatakanlah: Aku berlindung kepada Tuhan manusia, Raja manusia, Sembahan manusia, dari kejahatan (bisikan) setan yang bersembunyi, yang membisikkan (kejahatan) ke dalam dada manusia, dari (golongan) jin dan manusia.",
    fadl: "",
    count: 3,
  },
  {
    key: "duaa_masaa",
    title: "Doa Petang",
    text: "Kami telah memasuki waktu petang dan kerajaan hanya milik Allah, segala puji bagi Allah. Tidak ada Tuhan selain Allah semata, tidak ada sekutu bagi-Nya. Milik-Nya kerajaan dan bagi-Nya segala pujian, dan Dia Maha Kuasa atas segala sesuatu. Ya Tuhanku, aku memohon kepada-Mu kebaikan malam ini dan kebaikan setelahnya, dan aku berlindung kepada-Mu dari kejahatan malam ini dan kejahatan setelahnya. Ya Tuhanku, aku berlindung kepada-Mu dari kemalasan dan keburukan masa tua. Ya Tuhanku, aku berlindung kepada-Mu dari siksa neraka dan siksa kubur.",
    fadl: "",
    count: 1,
  },
  {
    key: "sayyid_istighfar",
    title: "Sayyidul Istighfar (Penghulu Istighfar)",
    text: "Ya Allah, Engkau adalah Tuhanku, tidak ada Tuhan selain Engkau. Engkau menciptakanku dan aku adalah hamba-Mu. Aku akan setia pada perjanjianku dengan-Mu dan janjiku kepada-Mu semampuku. Aku berlindung kepada-Mu dari kejahatan yang telah kuperbuat. Aku mengakui nikmat-Mu kepadaku dan aku mengakui dosaku. Maka ampunilah aku, karena tidak ada yang mengampuni dosa selain Engkau.",
    fadl: "Barangsiapa membacanya dengan penuh keyakinan ketika petang dan mati pada malam harinya, ia akan masuk surga",
    count: 1,
  },
  {
    key: "rida",
    title: "Ridha dengan Allah sebagai Tuhan",
    text: "Aku ridha Allah sebagai Tuhan, Islam sebagai agama, dan Muhammad ﷺ sebagai nabi",
    fadl: "Barangsiapa mengucapkannya ketika pagi dan petang, maka menjadi hak Allah untuk meridhainya pada hari kiamat",
    count: 3,
  },
  {
    key: "shahada_tawheed",
    title: "Kesaksian Tauhid",
    text: "Ya Allah, sesungguhnya aku pada petang ini mempersaksikan Engkau, dan mempersaksikan para pemikul Arasy-Mu, malaikat-Mu, dan seluruh makhluk-Mu, bahwa sesungguhnya Engkau adalah Allah, tidak ada Tuhan selain Engkau semata, tidak ada sekutu bagi-Mu, dan bahwa Muhammad adalah hamba dan utusan-Mu",
    fadl: "Barangsiapa mengucapkannya, Allah akan membebaskannya dari api neraka",
    count: 4,
  },
  {
    key: "shukr_nima",
    title: "Syukur Nikmat",
    text: "Ya Allah, nikmat apa pun yang ada padaku atau pada salah seorang dari makhluk-Mu pada petang ini, maka semuanya dari-Mu semata, tidak ada sekutu bagi-Mu. Maka segala puji bagi-Mu dan syukur kepada-Mu",
    fadl: "Barangsiapa mengucapkannya ketika petang, maka ia telah menunaikan syukur untuk harinya",
    count: 1,
  },
  {
    key: "hasbiyallah",
    title: "Cukuplah Allah Bagiku",
    text: "Cukuplah Allah bagiku, tidak ada Tuhan selain Dia. Kepada-Nya aku bertawakal, dan Dia adalah Tuhan pemilik Arasy yang agung",
    fadl: "Barangsiapa mengucapkannya, maka Allah akan mencukupinya dari segala yang merisaukannya dari urusan dunia dan akhirat",
    count: 7,
  },
  {
    key: "bismillah_hifz",
    title: "Bismillah untuk Perlindungan",
    text: "Dengan nama Allah yang bersama nama-Nya tidak ada sesuatu pun di bumi dan di langit yang membahayakan, dan Dia Maha Mendengar, Maha Mengetahui",
    fadl: "Tidak akan membahayakannya sesuatu pun",
    count: 3,
  },
  {
    key: "hayat_mamat",
    title: "Doa Kehidupan dan Kematian",
    text: "Ya Allah, dengan-Mu kami memasuki waktu petang, dengan-Mu kami memasuki waktu pagi, dengan-Mu kami hidup, dengan-Mu kami mati, dan kepada-Mu tempat kembali",
    fadl: "",
    count: 1,
  },
  {
    key: "fitrat_islam",
    title: "Fitrah Islam",
    text: "Kami memasuki waktu petang di atas fitrah Islam, kalimat ikhlas, agama Nabi kita Muhammad ﷺ, dan agama bapak kami Ibrahim yang lurus dan muslim, dan dia tidak termasuk orang-orang musyrik",
    fadl: "",
    count: 1,
  },
  {
    key: "subhan_full",
    title: "Subhanallah wa Bihamdih (Lengkap)",
    text: "Maha Suci Allah dan segala puji bagi-Nya sebanyak bilangan makhluk-Nya, sebanyak keridhaan diri-Nya, seberat timbangan Arasy-Nya, dan sebanyak tinta kalimat-kalimat-Nya",
    fadl: "",
    count: 3,
  },
  {
    key: "afiya",
    title: "Doa Keselamatan (Afiyah)",
    text: "Ya Allah, selamatkanlah badanku. Ya Allah, selamatkanlah pendengaranku. Ya Allah, selamatkanlah penglihatanku. Tidak ada Tuhan selain Engkau",
    fadl: "",
    count: 3,
  },
  {
    key: "kufr_faqr",
    title: "Perlindungan dari Kekufuran dan Kemiskinan",
    text: "Ya Allah, aku berlindung kepada-Mu dari kekufuran, kemiskinan, dan aku berlindung kepada-Mu dari siksa kubur. Tidak ada Tuhan selain Engkau",
    fadl: "",
    count: 3,
  },
  {
    key: "afw_afiya",
    title: "Doa Ampunan dan Keselamatan",
    text: "Ya Allah, aku memohon kepada-Mu ampunan dan keselamatan di dunia dan akhirat. Ya Allah, aku memohon kepada-Mu ampunan dan keselamatan dalam agamaku, duniaku, keluargaku, dan hartaku. Ya Allah, tutuplah auratku dan amankanlah ketakutanku. Ya Allah, lindungilah aku dari depan, dari belakang, dari kanan, dari kiri, dan dari atasku. Dan aku berlindung dengan kebesaran-Mu agar tidak dibunuh dari bawahku",
    fadl: "",
    count: 1,
  },
  {
    key: "ya_hayy",
    title: "Ya Hayyu Ya Qayyum",
    text: "Wahai Yang Maha Hidup, wahai Yang Maha Mandiri, dengan rahmat-Mu aku memohon pertolongan. Perbaikilah seluruh urusanku, dan janganlah Engkau serahkan aku kepada diriku sendiri meskipun sekejap mata",
    fadl: "",
    count: 3,
  },
  {
    key: "khayr_layla",
    title: "Doa Kebaikan Malam",
    text: "Kami telah memasuki waktu petang dan kerajaan hanya milik Allah, Tuhan semesta alam. Ya Allah, sesungguhnya aku memohon kepada-Mu kebaikan malam ini: kemenangannya, cahayanya, keberkahannya, dan petunjuknya. Dan aku berlindung kepada-Mu dari kejahatan yang ada di dalamnya dan kejahatan setelahnya",
    fadl: "",
    count: 1,
  },
  {
    key: "shar_nafs",
    title: "Perlindungan dari Kejahatan Diri",
    text: "Ya Allah, Yang Maha Mengetahui yang gaib dan yang nyata, Pencipta langit dan bumi, Tuhan dan Penguasa segala sesuatu. Aku bersaksi bahwa tidak ada Tuhan selain Engkau. Aku berlindung kepada-Mu dari kejahatan diriku, dari kejahatan setan dan sekutunya, dan dari berbuat buruk terhadap diriku atau menimpakannya kepada seorang muslim",
    fadl: "",
    count: 1,
  },
  {
    key: "kalimat_allah",
    title: "Perlindungan dengan Kalimat-Kalimat Allah",
    text: "Aku berlindung dengan kalimat-kalimat Allah yang sempurna dari kejahatan makhluk yang Dia ciptakan",
    fadl: "",
    count: 3,
  },
  {
    key: "salawat",
    title: "Shalawat kepada Nabi ﷺ",
    text: "Ya Allah, limpahkanlah shalawat, salam, dan berkah kepada Nabi kami Muhammad",
    fadl: "Barangsiapa bershalawat kepadanya ketika pagi dan petang, maka syafaatnya akan menyertainya pada hari kiamat",
    count: 10,
  },
  {
    key: "shirk",
    title: "Perlindungan dari Syirik",
    text: "Ya Allah, sesungguhnya kami berlindung kepada-Mu dari mempersekutukan-Mu dengan sesuatu yang kami ketahui, dan kami memohon ampun kepada-Mu untuk apa yang tidak kami ketahui",
    fadl: "",
    count: 3,
  },
  {
    key: "hamm_huzn",
    title: "Perlindungan dari Kesedihan dan Kesusahan",
    text: "Ya Allah, aku berlindung kepada-Mu dari kesedihan dan kesusahan, aku berlindung kepada-Mu dari kelemahan dan kemalasan, aku berlindung kepada-Mu dari sifat pengecut dan kikir, dan aku berlindung kepada-Mu dari lilitan utang dan tekanan orang-orang",
    fadl: "",
    count: 3,
  },
  {
    key: "istighfar_azeem",
    title: "Istighfar Agung",
    text: "Aku memohon ampun kepada Allah Yang Maha Agung, yang tidak ada Tuhan selain Dia, Yang Maha Hidup, Yang Maha Mandiri, dan aku bertobat kepada-Nya",
    fadl: "",
    count: 3,
  },
  {
    key: "hamd_jalal",
    title: "Pujian atas Keagungan",
    text: "Wahai Tuhanku, segala puji bagi-Mu sebagaimana layak untuk keagungan wajah-Mu dan kebesaran kekuasaan-Mu",
    fadl: "",
    count: 3,
  },
  {
    key: "la_ilaha_100",
    title: "La ilaha illallah (100x)",
    text: "Tidak ada Tuhan selain Allah semata, tidak ada sekutu bagi-Nya. Milik-Nya kerajaan dan bagi-Nya segala pujian, dan Dia Maha Kuasa atas segala sesuatu",
    fadl: "Itu sama dengan memerdekakan sepuluh budak, ditulis baginya seratus kebaikan, dihapus darinya seratus keburukan, dan menjadi benteng baginya dari setan",
    count: 100,
  },
  {
    key: "tawakkul",
    title: "Tawakal dan Daya Upaya",
    text: "Ya Allah, Engkau adalah Tuhanku, tidak ada Tuhan selain Engkau. Kepada-Mu aku bertawakal, dan Engkau adalah Tuhan pemilik Arasy yang agung. Apa yang dikehendaki Allah akan terjadi, dan apa yang tidak dikehendaki-Nya tidak akan terjadi. Tidak ada daya dan kekuatan kecuali dengan pertolongan Allah Yang Maha Tinggi lagi Maha Agung. Aku mengetahui bahwa Allah Maha Kuasa atas segala sesuatu, dan bahwa ilmu Allah meliputi segala sesuatu. Ya Allah, aku berlindung kepada-Mu dari kejahatan diriku, dan dari kejahatan setiap makhluk yang Engkau pegang ubun-ubunnya. Sesungguhnya Tuhanku berada di jalan yang lurus",
    fadl: "Dzikir yang baik",
    count: 1,
  },
  {
    key: "subhan_100",
    title: "Subhanallah wa Bihamdih (100x)",
    text: "Maha Suci Allah dan segala puji bagi-Nya",
    fadl: "Dihapuskan dosa-dosanya meskipun sebanyak buih di lautan",
    count: 100,
  },
];

const playDoneSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784].forEach((freq, i) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.type = "sine";
      oscillator.frequency.value = freq;
      const t = audioContext.currentTime + i * 0.13;
      gainNode.gain.setValueAtTime(0.2, t);
      gainNode.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
      oscillator.start(t);
      oscillator.stop(t + 0.3);
    });
  } catch (error) {
    console.log("Audio play failed:", error);
  }
};

const AthkarAlMasaa = () => {
  const initialCounts = {};
  athkarList.forEach((a) => { initialCounts[a.key] = 0; });

  const [counts, setCounts] = useState(initialCounts);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleIncrement = (key, target) => {
    setCounts((prev) => {
      const newCount = (prev[key] || 0) + 1;
      if (newCount === target) {
        playDoneSound();
        setSnackbarMessage(`Selamat! Anda telah menyelesaikan dzikir ini ✅`);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 4000);
      }
      return { ...prev, [key]: newCount };
    });
  };

  const handleDecrement = (key) => {
    setCounts((prev) => ({
      ...prev,
      [key]: Math.max((prev[key] || 0) - 1, 0),
    }));
  };

  const handleReset = (key) => {
    setCounts((prev) => ({ ...prev, [key]: 0 }));
  };

  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />

      <div className="row">
        <div className="col-12 col-md-8">
          <div className="bg-success text-white text-center" style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>
              Dzikir Petang - Benteng Muslim
            </h1>
          </div>

          <div
            className="border border-light shadow-lg p-4 rounded"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "10px",
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
            }}
          >
            <div className="row">
              <div>
                <p>
                  Dzikir petang adalah doa dan dzikir yang berasal dari Benteng Muslim, diucapkan pada waktu petang sebagai perlindungan untuk malam hari. Tekan lingkaran untuk mencatat setiap bacaan dzikir, gunakan tombol "Kurangi" untuk mengoreksi jumlah atau "Reset" untuk memulai dari awal.{" "}
                  <b>
                    Penghitung menunjukkan target dan sisa untuk setiap dzikir, dan saat selesai akan mengeluarkan bunyi peringatan.
                  </b>
                </p>
                <p>
                  Anda dapat memantau kemajuan Anda dalam setiap dzikir dan mengetahui berapa banyak yang tersisa untuk menyelesaikannya, yang membantu Anda untuk konsisten dalam dzikir petang setiap hari dengan mudah. Semoga Allah membalas Anda dengan kebaikan atas kesungguhan Anda dalam berdzikir kepada Allah di setiap waktu.
                </p>

              </div>
            </div>

            {athkarList.map((item) => {
              const current = counts[item.key] || 0;
              const isDone = current >= item.count;
              const remaining = Math.max(item.count - current, 0);

              return (
                <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                  <div className="col calculatorStyle">
                    {/* Card Header */}
                    <div className="p-3 mb-2 bg-success text-white text-center">
                      <h2 style={{ fontSize: "22px", marginBottom: item.fadl ? "6px" : "0" }}>
                        {item.title}
                      </h2>
                      {item.fadl && (
                        <p style={{ fontSize: "13px", color: "#d4edda", margin: 0 }}>
                          ✦ {item.fadl}
                        </p>
                      )}
                    </div>

                    <hr />

                    <div >
                      {/* Dhikr Text */}
                      <p style={{ fontSize: "18px", lineHeight: "2", textAlign: "center", color: "#333", whiteSpace: "pre-line" }}>
                        {item.text}
                      </p>

                      <hr />

                      {/* Circle Counter */}
                      <div className="text-center my-4">
                        <div
                          style={{
                            background: isDone
                              ? "linear-gradient(135deg, #d4edda 0%, #a8d5b5 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                            color: isDone ? "#198754" : "#4caf50",
                            borderRadius: "50%",
                            width: "300px",
                            height: "300px",
                            fontSize: "70px",
                            fontWeight: "bold",
                            margin: "0 auto",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            cursor: isDone ? "default" : "pointer",
                            userSelect: "none",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                          onClick={() => !isDone && handleIncrement(item.key, item.count)}
                        >
                          {current}
                          {isDone && (
                            <span style={{ fontSize: "20px", display: "block", marginTop: "8px" }}>✅</span>
                          )}
                        </div>
                      </div>

                      {/* Target & Remaining */}
                      <div className="text-center" style={{ fontSize: "16px", color: "#198754", marginBottom: "12px" }}>
                        Target: <strong>{item.count}</strong> &nbsp;|&nbsp; Sisa: <strong>{remaining}</strong>
                      </div>

                      <br />

                      {/* Action Buttons */}
                      <div className="text-center mt-2">
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
                          <button
                            className="text-white px-4 py-2"
                            style={{
                              background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              padding: "15px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDecrement(item.key)}
                          >
                            Kurangi
                          </button>
                          <button
                            className="text-white px-4 py-2"
                            style={{
                              background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              padding: "15px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleReset(item.key)}
                          >
                            Reset
                          </button>
                        </div>

                        {isDone && (
                          <div
                            className="mt-3"
                            style={{
                              backgroundColor: "#d4edda",
                              color: "#155724",
                              borderRadius: "10px",
                              padding: "10px",
                              fontSize: "15px",
                              fontWeight: "bold",
                            }}
                          >
                            ✅ Anda telah menyelesaikan dzikir ini, semoga Allah membalas Anda dengan kebaikan
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>

        <div className="col">
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      {/* Snackbar */}
      {snackbarOpen && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#198754",
            color: "white",
            padding: "14px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "bold",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            zIndex: 9999,
          }}
        >
          {snackbarMessage}
        </div>
      )}
    </div>
  );
};

export default AthkarAlMasaa;